'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var throttle = require('lodash/function/throttle');

var scrollBlocker = require('scroll-blocker');
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var debounce = require('lodash/function/debounce');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var statusMsg = require('./side-panel-status-msg');
var dom;
var customFieldTimer;

var setupDom = function() {

	dom = {};

};

var addEventHandlers = function() {

	console.log('buy-panel addEventHandlers called');

	appDom.document.on('click', '.product-detail__add-image-to-product-btn', onAddImageToProductBtnClicked);
	appDom.document.on('click', '.product-detail__remove-image-from-product-btn', onRemoveImageFromProductBtnClicked);
	appDom.document.on('click', '.product-detail__edit-link', onEditLinkClicked);

};

var onEditLinkClicked = function(e) {

	e.preventDefault();

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: 'product_detail',
			detail: true,
			itemKey: $(this).attr('data-item-key')
		}
	}).done(function(response) {

		sidePanel.open(response.markup);

	});

};

var onRemoveImageFromProductBtnClicked = function(e) {

	var $link = $(this);
	var productId = $link.attr('data-product-id');
	var photoId = $link.attr('data-photo-id');
	var itemKey = $link.attr('data-item-key');

	e.preventDefault();
	e.stopPropagation();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			productId: productId,
			photoId: photoId,
			itemKey: itemKey
		}
	}).done(function() {

		renderProductImagesPanel(false);

	});

};

var onAddImageToProductBtnClicked = function(e) {

	var $link = $(this);
	var photoId = $link.attr('data-photo-id');
	var itemKey = $link.attr('data-item-key');

	e.preventDefault();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			photoId: photoId,
			itemKey: itemKey
		}
	}).done(function(response) {

		if (response.status.code) {

			renderProductImagesPanel(true);

		} else {

			notify.show({
				target: $('[name="' + response.target + '"]'),
				msg: response.status.msg,
				closeOnClick: true
			});

		}


	});

};

var renderProductImagesPanel = function(addedToCart) {

	var $productForm = $('.product-detail__form');

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: 'product_images'
		}
	}).done(function(response) {

		sidePanel.open(response.markup);

		if (addedToCart) {

			if ($productForm.attr('data-is-product-in-cart') === 'true') {

				statusMsg.show('cart_updated');

			} else {

				statusMsg.show('added_to_cart');

			}

		}

	});

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
